import { useState } from "react";

import useModule from "../../hooks/useModule";
import CustomTableLayout from "../CustomTableLayout";
import ShareScreenDrawer from "../../components/PageView/ShareScreenDrawer/ShareScreenDrawer";
import SharedCenterSelectedRecordsActions from "./SharedCenterSelectedRecordsActions";

const mainLayout = {
  id: "1",
  Fields: ["DocumentID", "Authentication", "Created", "LastUpdated"],
  ModuleAPIName: "SharedDocuments",
  Type: "Table",
};

const initialQuery = {
  _SelectedLayout: "1",
  Fields: [
    "_RecordName",
    "DocumentID",
    "Authentication",
    "Created",
    "LastUpdated",
  ],
  Filters: [],
  OrderBy: {
    Field: "Created",
    Direction: "DESC",
  },
  Pagination: {
    Count: 25,
    Page: 1,
  },
};

const hiddenFields = ["DocumentID"];

const SharedDocumentsCenter = () => {
  const { module } = useModule("SharedDocuments");
  const [openSharedDocument, setOpenSharedDocument] = useState<
    string | undefined
  >(undefined);

  if (!module) return;

  return (
    <>
      <CustomTableLayout
        title="Shared Documents"
        description="All the documents shared in this cloud"
        module={module}
        layout={mainLayout}
        initialQuery={initialQuery}
        recordNameField="DocumentID"
        hiddenFields={hiddenFields}
        onOpenRecordName={(data) => {
          const record = data.record;
          setOpenSharedDocument(record?.DocumentID.id);
        }}
        SelectRecordsActions={SharedCenterSelectedRecordsActions}
      />
      <ShareScreenDrawer
        open={!!openSharedDocument}
        onClose={() => setOpenSharedDocument(undefined)}
        documentID={openSharedDocument}
        viewID={undefined}
        recordID={undefined}
        pageID={undefined}
        parentViewID={undefined}
        recordModule={undefined}
      />
    </>
  );
};

export default SharedDocumentsCenter;
